import Base from "../../../../class/Base"
import Comment from "../../Comment"
import {User} from "../../entity"

export default class VComment extends Base {}
VComment.addProperties({
	comment : Comment,
	author : User,
});
